import { AssessmentLevel } from '../roleplay-assessment.types'

/**
 * 評価レベルに応じたMaterial Iconマッピング。
 * アドオン間で共有可能。カスタマイズ時はこの定数を拡張または上書きする。
 */
export const ASSESSMENT_ICON_MAP: Record<AssessmentLevel, string> = {
  Bad: 'sentiment_dissatisfied',
  Normal: 'sentiment_neutral',
  Good: 'sentiment_satisfied',
  Excellent: 'emoji_events',
}

/**
 * 評価レベルに応じた背景色マッピング。
 * HISTORYビューの暗背景コンテキストに最適化した低不透明度カラー。
 * Materialテーマのwarn(red)/primary(slate)パレットから派生。
 */
export const ASSESSMENT_BG_COLOR_MAP: Record<AssessmentLevel, string> = {
  Bad: 'rgba(239, 68, 68, 0.12)',
  Normal: 'rgba(169, 148, 57, 0.12)',
  Good: 'rgba(34, 197, 94, 0.12)',
  Excellent: 'rgba(234, 179, 8, 0.12)',
}

/**
 * 評価レベルに応じたアイコン色マッピング。
 * 暗背景上での視認性を確保するアクセントカラー。
 */
export const ASSESSMENT_ICON_COLOR_MAP: Record<AssessmentLevel, string> = {
  Bad: '#fca5a5',
  Normal: '#d5d188',
  Good: '#86efac',
  Excellent: '#fde047',
}
